export enum LinkStyle {
    Primary = 'primary',
    Secondary = 'secondary',
}
